import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  standalone: false,
  selector: 'app-authorizations',
  templateUrl: './authorizations.component.html',
  styleUrls: ['./authorizations.component.sass']
})
export class AuthorizationsComponent implements OnInit, OnChanges {
  @Output() authorization = new EventEmitter<any>();
  @Output() eventClick = new EventEmitter<any>();
  @Input() authorizationType: string;
  public hidePassword = true;
  public myForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder
  ) {
    this.myForm = formBuilder.group({
      username: [''],
      password: [''],
      action: [],
      codControl: []
    });
  }

  ngOnChanges() {
    this.myForm.controls['action'].setValue(this.authorizationType);
  }

  ngOnInit() {
    this.myForm.valueChanges.subscribe(change => {
      if (this.myForm.valid) {
        this.authorization.emit(change);
      } else {
        this.authorization.emit(null);
      }
    });

    this.myForm.controls['action'].valueChanges.subscribe(change => {
      this.myForm.controls['codControl'].clearValidators();
      this.myForm.controls['username'].clearValidators();
      this.myForm.controls['password'].clearValidators();
      if (change === 'code') {
        this.myForm.controls['codControl'].setValidators([Validators.required, Validators.maxLength(8)]);
      } else {
        this.myForm.controls['username'].setValidators([Validators.required, Validators.min(4)]);
        this.myForm.controls['password'].setValidators([Validators.required, Validators.min(4)]);
      }
      this.myForm.controls['codControl'].updateValueAndValidity();
      this.myForm.controls['username'].updateValueAndValidity();
      this.myForm.controls['password'].updateValueAndValidity();
    });
  }

  onClick() {
    if (this.myForm.valid) {
      this.eventClick.emit(this.myForm.value);
    } else {
      this.eventClick.emit(null);
    }
  }

  reset() {
    this.myForm.reset();
  }
}
